import { refSousType } from "./data/refs";

// src/PointCodeGenerator.js - VERSION FINALE CC5
export class PointCodeGenerator {
  static generateCode(pointForm = {}) {
    // 🆕 Point libre → code spécial "?" sans optionnels
    if (pointForm.familleCode === '?') {
      return '?;;;;';
    }

    const mainCode = this.getMainCode(pointForm);
    if (!this.isValidMainCode(pointForm)) {
      throw new Error("❌ Famille et Résultat obligatoires");
    }
    const optionnels = [
      pointForm.serviceReussite || "",
      pointForm.zoneCode || "",
      pointForm.effetCode || "",
      pointForm.fauteDirecteCode || ""
    ].join(";");
    return `${mainCode};${optionnels}`;  // "S1S3F;;;" ou "S1S3;;;"
  }

  static getValidSousTypes(familleCode) {
    return refSousType[familleCode] || [];
  }

  static isValidSousType(familleCode, sousTypeCode) {
    const validSousTypes = this.getValidSousTypes(familleCode);
    return validSousTypes.some(st => st.code === sousTypeCode);
  }

  static getMainCode(pointForm = {}) {
    // 🆕 Point libre → code "?"
    if (pointForm.familleCode === '?') return '?';

    const famille = pointForm.familleCode || "";
    let sousType = pointForm.sousTypeCode || "";
    
    // FIX : sousType invalide → ""
    if (sousType && !this.isValidSousType(famille, sousType)) {
      console.log(`⚠️ Sous-type "${sousType}" invalide pour famille "${famille}" → reset`);
      sousType = "";
    }
    
    const parts = [famille, sousType, pointForm.nbFrappesCode || ""];
    if (pointForm.resultatCode === "F") parts.push("F");
    
    return parts.join("");
  }

  static isValidMainCode(pointForm) {
    const famille = pointForm.familleCode;
    const resultat = pointForm.resultatCode;
    
    console.log("🔍 VALID PointCodeGenerator:", { famille, resultat });

    // 🆕 Point libre → toujours valide
    if (famille === '?') return true;
    
    const familleValide = ['S', 'T', 'C', 'R', 'V'].includes(famille);
    const resultatValide = resultat === "" || resultat === "F";  // Point("") ou Faute("F") - REFUSE null
    
    const isValid = familleValide && resultatValide;
    console.log("🔍 PointCodeGenerator isValid:", isValid);
    
    return isValid;
  }

  static parseCode(fullCode = "") {
    const parts = fullCode.split(";");
    return {
      mainCode: parts[0] || "",
      serviceReussite: parts[1] || "",
      zoneCode: parts[2] || "",
      effetCode: parts[3] || "",
      fauteDirecteCode: parts[4] || "",
    };
  }

  static parseMainCode(mainCode = "") {
    // 🆕 Point libre → retourner directement
    if (mainCode === '?') {
      return { famille: '?', sousType: '', nbFrappes: '', resultat: '' };
    }

    const parts = mainCode.split("");
    return {
      famille: parts[0] || "",
      sousType: parts[1] || "",
      nbFrappes: parts[2] || "",
      resultat: parts[3] || ""
    };
  }
}